import { FC } from 'react'

import { ISvgClass } from '../interface'

const ArrowLeftIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="7"
      height="10"
      viewBox="0 0 7 10"
      fill="none"
      {...props}
    >
      <path
        d="M6.8249 1.175L5.6499 0L0.649902 5L5.6499 10L6.8249 8.825L3.00824 5L6.8249 1.175Z"
        fill="inherit"
      />
    </svg>
  )
}

export default ArrowLeftIcon
